import { render, staticRenderFns } from "./ExtraDialog.vue?vue&type=template&id=ce4122da"
import script from "./ExtraDialog.vue?vue&type=script&lang=js"
export * from "./ExtraDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports